import React from "react";
import { Briefcase, FileText, Building2 } from "lucide-react";

const StatCard = ({ label, value, icon: Icon, color, bg }) => (
  <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow">
    <div className="flex justify-between items-start">
      <div>
        <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">
          {label}
        </p>
        <p className={`text-2xl font-bold mt-1 ${color}`}>{value}</p>
      </div>
      <div className={`p-2 rounded-lg ${bg} ${color}`}>
        <Icon size={20} />
      </div>
    </div>
  </div>
);

const DashboardStats = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
      <StatCard
        label="Tổng Workspace"
        value={stats.total}
        icon={Briefcase}
        color="text-slate-900"
        bg="bg-blue-50 text-blue-600" // Override icon color style
      />
      <StatCard
        label="Có ĐKKD"
        value={stats.hasLicense}
        icon={FileText}
        color="text-emerald-600"
        bg="bg-emerald-50"
      />
      <StatCard
        label="Chưa phân loại"
        value={stats.total - stats.hasType}
        icon={Building2}
        color="text-orange-600"
        bg="bg-orange-50"
      />
    </div>
  );
};

export default DashboardStats;